'use strict';

define('FavoriteTracksFac',['PreferencesEntityBuilder'], function (PreferencesEntityBuilder) {

    function FavoriteTracksFac(PreferencesFac, $q, FavoriteCookieFac) {

        var FAVORITE_TRACKS_KEY = 'FAVORITE_TRACKS';
        var favoriteTracks = [];
        var loaded = false;

        function _retrieveFavoriteTracksList(preference) {
            var trackList = preference.metadata.split(',');
            favoriteTracks = trackList;
            loaded = true;
        }

        var favoriteTracksFac =  {
            clearFavoriteList: function () {
                loaded = false;
                favoriteTracks.length = 0;
            },
            loadFavoriteTracks: function() {
                if (loaded) {
                    return $q.when();
                }
                return PreferencesFac
                    .getUniquePreference(FAVORITE_TRACKS_KEY)
                    .then(_retrieveFavoriteTracksList);
            },
            getFavoriteTracks: function() {
                return favoriteTracks;
            },
            updateFavoriteTracks: function(favoriteTrackList) {
                var metadata = favoriteTrackList.join(',');
                var postData = PreferencesEntityBuilder()
                    .withMetadata(metadata)
                    .withDescription(FAVORITE_TRACKS_KEY)
                    .build();
                return PreferencesFac.updatePreferences(postData).then(function(){
                    favoriteTracks = favoriteTrackList;

                    //TODO Remove this once all preferences update are on the micro service
                    FavoriteCookieFac.updateFavoriteTrackList(favoriteTrackList);
                });
            }
        };

        return {
            loadFavoriteTracks: favoriteTracksFac.loadFavoriteTracks,
            getFavoriteTracks: favoriteTracksFac.getFavoriteTracks,
            updateFavoriteTracks: favoriteTracksFac.updateFavoriteTracks,
            clearFavoriteList: favoriteTracksFac.clearFavoriteList
        };
    }

    FavoriteTracksFac.$inject = [
        'PreferencesFac',
        '$q',
        'FavoriteCookieFac'
    ];

    return FavoriteTracksFac;

});

